define('presentation/settings/accountProfile/presentationObjects/accountProfilePresentationObject',[],function() {
    return function() {
        const self = this;
        self.accountHolderFirstName = null;
        self.accountHolderLastName = null;
        self.businessName = null;
        self.country = null;
        self.addressLineOne = null;
        self.addressLineTwo = null;
        self.city = null;
        self.stateProvince = null;
        self.postalCode = null;
        self.inBusinessSince = null;
        self.numberOfEmployees = null;
        self.industry = null;
        self.timeZone = null;
        self.websiteUrl = null;
        self.pointOfContactFirstName = null;
        self.pointOfContactLastName = null;
        self.phoneNumber = null;
    };
});
